import { MsalProvider } from '@azure/msal-react'
import { FluentProvider } from '@fluentui/react-components'
import { QueryClientProvider } from '@tanstack/react-query'

import { ErrorBoundary } from './components/ErrorBoundary'
import { ToastBridge } from './components/ToastBridge'
import { msalInstance } from './config/msalInstanceHelper'
import { queryClient } from './config/query-client'
import './index.css'
import { CurrentUserProvider } from './providers/CurrentUserProvider'
import { DialogProvider } from './providers/DialogProvider'
import AppRoutes from './routes'
import { theme } from './styles/theme'
import { FluentToastProvider } from './utils/fluentToast'

function App() {
  return (
    <FluentProvider theme={theme} style={{ height: 'stretch', backgroundColor: 'inherit' }}>
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <FluentToastProvider>
              <DialogProvider>
                <ToastBridge />
                <CurrentUserProvider>
                  <AppRoutes />
                </CurrentUserProvider>
              </DialogProvider>
            </FluentToastProvider>
          </QueryClientProvider>
        </MsalProvider>
      </ErrorBoundary>
    </FluentProvider>
  )
}

export default App
